// Checks if option value is "empty"
export default function isEmpty(value) {
  return value === '.' || value === '';
}
